module.exports = __webpack_public_path__ + "static/media/icon-catalog-warning.ac9612fd.svg";